import { render, staticRenderFns } from "./MonthDeathCountsChat.vue?vue&type=template&id=731186d5&"
import script from "./MonthDeathCountsChat.vue?vue&type=script&lang=js&"
export * from "./MonthDeathCountsChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports